module.exports = __webpack_public_path__ + "img/icon_nico_menu.6b0d5261.svg";